import { Fragment } from "react";
import "./App.css";
import DotsBackground from "./DotsBackground";

const NAME = "Bobby Krishnan";
// Each word keeps its letters' positions in NAME so the stagger flows across the space.
const NAME_WORDS = NAME.split(" ").map((word, w, words) => ({
  word,
  start: words.slice(0, w).join(" ").length + (w > 0 ? 1 : 0),
}));

function App() {
  return (
    <div className="page">
      <DotsBackground />
      {/* Main content */}
      <div className="container">
        <section className="block">
          <h1 className="name" aria-label={NAME}>
            {NAME_WORDS.map(({ word, start }, w) => (
              <Fragment key={w}>
                {w > 0 && " "}
                <span className="name-word" aria-hidden="true">
                  {[...word].map((letter, i) => (
                    <span className="name-letter" style={{ "--i": start + i }} key={i}>
                      {letter}
                    </span>
                  ))}
                </span>
              </Fragment>
            ))}
          </h1>
          <p className="tagline fade-in">If you can't do what you imagine, then what is imagination to you</p>
        </section>
      <div className="socials fade-in">
        <a
          href="https://www.linkedin.com/in/abhishekkrishnan04/"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M4.98 3.5C4.98 4.88 3.86 6 2.49 6S0 4.88 0 3.5 1.12 1 2.49 1 4.98 2.12 4.98 3.5zM.2 8h4.6v15H.2V8zm7.8 0h4.4v2.05h.06c.61-1.15 2.1-2.36 4.32-2.36 4.62 0 5.48 3.04 5.48 7v8.31h-4.6v-7.36c0-1.76-.03-4.03-2.46-4.03-2.46 0-2.84 1.92-2.84 3.9v7.49H8V8z"/>
          </svg>
        </a>
        <a
          href="https://github.com/Bobby-Krishnan"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M12 .3a12 12 0 0 0-3.8 23.4c.6.1.8-.3.8-.6v-2c-3.3.7-4-1.6-4-1.6-.6-1.4-1.4-1.8-1.4-1.8-1-.7.1-.7.1-.7 1.2.1 1.8 1.2 1.8 1.2 1 1.8 2.8 1.3 3.5 1 0-.8.4-1.3.7-1.6-2.7-.3-5.5-1.3-5.5-6 0-1.2.5-2.3 1.3-3.1-.2-.4-.6-1.6 0-3.2 0 0 1-.3 3.4 1.2a11.5 11.5 0 0 1 6 0c2.3-1.5 3.3-1.2 3.3-1.2.6 1.6.2 2.8 0 3.2.9.8 1.3 1.9 1.3 3.2 0 4.6-2.8 5.6-5.5 5.9.5.4.9 1.1.9 2.3v3.3c0 .3.2.7.8.6A12 12 0 0 0 12 .3"/>
          </svg>
        </a>
      </div>

        <section className="block">
          <p className="section-title">Experience</p>

          <div className="entry">
            <p className="entry-title">Amazon Web Services</p>
            <p className="entry-sub">Software Development Engineer Intern</p>
            <p className="entry-desc">
              Worked within AWS Partner Central to develop a decision engine for the partner registration process.
            </p>
          </div>

          <div className="entry">
            <p className="entry-title">Scale AI</p>
            <p className="entry-sub">Generative AI Intern</p>
            <p className="entry-desc">
              Contributed to LLM infrastructure and evaluation systems.
            </p>
          </div>

          <div className="entry">
            <p className="entry-title">Duke University</p>
            <p className="entry-sub">Undergraduate Teaching Assistant</p>
            <p className="entry-desc">
              Compsci 364: Computer Game Development
            </p>
          </div>
        </section>

        <section className="block">
          <p className="section-title">Cases</p>

          <a
            href="https://github.com/Bobby-Krishnan/Shrinx"
            target="_blank"
            rel="noopener noreferrer"
            className="case"
          >
            Case 01 — Shrinx (LLM Compression)
          </a>

          <a
            href="https://github.com/Bobby-Krishnan/IMC-Prosperity-3"
            target="_blank"
            rel="noopener noreferrer"
            className="case"
          >
            Case 02 — IMC Trading Competition
            <span className="tag">Top 1%</span>
          </a>

          <a
            href="https://github.com/Bobby-Krishnan/Kai-s-Ascent"
            target="_blank"
            rel="noopener noreferrer"
            className="case"
          >
            Case 03 — Game Development (Unity)
          </a>

          <a
            href="https://github.com/Bobby-Krishnan/shadow_slave-_spoiler_safe_rag"
            target="_blank"
            rel="noopener noreferrer"
            className="case"
          >
            Case 04 — Spoiler Safe Novel RAG
          </a>

          <a
            href="https://github.com/Bobby-Krishnan/rips-ocr-public"
            target="_blank"
            rel="noopener noreferrer"
            className="case"
          >
            Case 05 — RIPS-OCR (Hidden-State Strategy Engine)
          </a>

          <a
            href="https://github.com/Bobby-Krishnan/lattice"
            target="_blank"
            rel="noopener noreferrer"
            className="case"
          >
            Case 06 — Lattice: Second Brain
          </a>
        </section>

        <section className="block footer">
          <p>Contact — Abhishek.Krishnan@duke.edu</p>
        </section>
      </div>
    </div>
  );
}

export default App;
